import useGenre from 'pages/AIMusicGenerator/useGenre';
import { urlManager } from 'services/api/config';
import { locations } from 'services/routes/locations';
import { Formula, VegaBundle } from 'services/store/ai/types';
import { generateFormulaSearchParams } from '../../helpers/formulaUrl';

interface GenerateFormulaUrlProps {
  primaryGenre: string;
  microGenre: string | null;
  formula: Formula;
}

const generateFormulaUrl = ({
  primaryGenre,
  microGenre,
  formula,
}: GenerateFormulaUrlProps) => {
  const { homepage } = urlManager;
  const { origin } = window.location;
  const { pathname } = locations.general.aiMusicGenerator;
  const queryString = generateFormulaSearchParams({
    primaryGenre,
    microGenre,
    formula,
  });
  return `${origin}${homepage}${pathname}?${queryString}`;
};

export const useFormulaUrl = (bundle: VegaBundle) => {
  const { genre, formula } = bundle;
  const genreName = useGenre(genre)?.name;

  if (!genreName || genreName === genre) {
    return generateFormulaUrl({
      primaryGenre: genre,
      microGenre: null,
      formula,
    });
  }

  return generateFormulaUrl({
    primaryGenre: genreName,
    microGenre: genre,
    formula,
  });
};
